module.exports = __webpack_public_path__ + "static/media/foto2.f7479ee7.gif";